/**
 * 车窗无忧
 */
import { WINDOWRECORD } from '../types';

export default {
    name: `${WINDOWRECORD}`,
    path: '/windowRecord',
    component: () => import(/* webpackChunkName: 'windowRecord' */ '@/views/windowRecord/'),
    redirect: { name: `${WINDOWRECORD}Index` },
    meta: {
        title: '车窗无忧',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${WINDOWRECORD}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'windowRecord' */ '@/views/windowRecord/home/Home.vue'),
        },

        // 二级页面示例, 没有二级页面就直接删掉
        {
            name: `${WINDOWRECORD}Detail`,
            path: 'detail/:id',
            component: () => import(/* webpackChunkName: 'windowRecord' */ '@/views/windowRecord/detail/Detail.vue'),
        },
    ],
};
